import { React, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link } from "react-router-dom";
import "../projects/projects.css";
import api from "../../utils/api";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

export const Internship = () => {
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const [internships, setInternships] = useState([]);

  useEffect(() => {
    api
      .get("/internships")
      .then((res) => {
        console.log("internships>", res.data);
        let arr = res.data?.filter((r) => (r?.generalData ? true : false));
        setInternships(arr);
        // let array = res.data;
        // let temp = res.data;
        // var n = array.length;
        // var j = 0;
        // for (var i = 0; i < 40; i++) {
        //   if (j === n) {
        //     i = 0;
        //   }
        //   array.push(temp[j]);
        //   j++;
        // }
        // setInternships(array);
      })
      .catch((err) => console.log(err));
  }, []);
  const [itemsPerPage, setItemsPerPage] = useState(9);
  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    const endOffset = itemOffset + itemsPerPage;
    setCurrentItems(internships.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(internships.length / itemsPerPage));
  }, [itemOffset, itemsPerPage, internships]);

  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % internships.length;
    console.log(
      `User requested page number ${event.selected}, which is offset ${newOffset}`
    );
    setItemOffset(newOffset);
  };

  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-12 col-12">
          {/* <div className="row mt-3">
            <div className="col-6">
              <h3>Internships:</h3>
            </div>
            {!currentUser?.isAdmin && (
              <div className="col-6">
                <Link to="/internship/post" className="btn-link">
                  Post an Internship
                </Link>
              </div>
            )}
          </div> */}
          <div className="container">
            {/* {internships.length > 0 && internships.map((inte) => <></>)} */}
            <Items
              currentItems={internships}
              setCurrentItems={setCurrentItems}
            />

            {/* <ReactPaginate
              nextLabel="next >"
              onPageChange={handlePageClick}
              pageRangeDisplayed={3}
              marginPagesDisplayed={2}
              pageCount={pageCount}
              previousLabel="< previous"
              pageClassName="page-item"
              pageLinkClassName="page-link"
              previousClassName="page-item"
              previousLinkClassName="page-link"
              nextClassName="page-item"
              nextLinkClassName="page-link"
              breakLabel="..."
              breakClassName="page-item"
              breakLinkClassName="page-link"
              containerClassName="pagination"
              activeClassName="active"
              renderOnZeroPageCount={null}
            /> */}
          </div>
          {/* <Link to="/internship/userinternship">
            <button
              className="btn"
              style={{ marginTop: "5vh", marginBottom: "5vh" }}
            >
              User Internships
            </button>
          </Link> */}
        </div>
      </div>
    </div>
  );
};

function Items({ currentItems, setCurrentItems }) {
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  useEffect(() => {
    console.log("current  items to check>>> ", currentItems);
    setCurrentItems([]);
  }, []);

  return (
    <>
      <div className="container feeds">
        {currentItems &&
          currentItems
            ?.sort(function (a, b) {
              return new Date(b.updatedAt) - new Date(a.updatedAt);
            })
            ?.map((inte) => (
              <Inte inte={inte} />
              // <div className="row border-bottom border-dark pb-3">
              //   <div className="col-lg-6 col-md-6 col-12">
              //     <h5 className="title">
              //       <strong>{inte?.companyName}</strong>
              //     </h5>
              //   </div>
              //   <div className="col-lg-6 col-md-6 col-12">
              //     <p>
              //       Posted:{" "}
              //       <strong className="date">
              //         {new Date(inte?.createdAt).toDateString()}
              //       </strong>
              //     </p>
              //   </div>
              //   <div className="country">
              //     <p>
              //       <strong>Location: </strong>
              //       {inte?.location}
              //     </p>
              //   </div>
              //   <div className="duration">
              //     <p>
              //       <strong>Duration: </strong> {inte?.duration}
              //     </p>
              //   </div>
              //   <div className="Paid/Stipend">
              //     <p>
              //       <strong>Paid/Stipend: </strong> {inte?.pay}
              //     </p>
              //   </div>

              //   <div className="desc">
              //     <p>
              //       <strong>Description: </strong>
              //       {inte?.description}
              //     </p>
              //   </div>

              //   <div className="visitlink">
              //     <h5 className="my-3">Visit Link</h5>
              //     <a href={inte?.url}>{inte?.url}</a>
              //   </div>
              //   {currentUser?.isAdmin && (
              //     <button
              //       className=" btn-link col-6 mr-auto mt-3 mb-3"
              //       onClick={() => deleteInternship(inte)}
              //     >
              //       Delete Internship
              //     </button>
              //   )}
              // </div>
            ))}
      </div>
    </>
  );
}

export const Inte = ({ inte }) => {
  const [uploader, setUploader] = useState("");
  useEffect(() => {
    // console.log("hostel", inte);
    inte?.userId &&
      api
        .get(`/user/getUserdataById/` + inte?.userId)
        .then((res) => {
          // console.log("user", res?.data);
          setUploader(res?.data);
        })
        .catch((err) => console.log("err", err));
  }, [inte]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const navigate = useNavigate();

  const deleteInternship = (i) => {
    api
      .delete(`/internships/${i?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your internships for violating terms and conditions.`,
            forAll: false,
            receiverId: i?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <>
      <Card
        sx={{
          width: "100%",
          marginTop: "20px",
          boxShadow: "rgba(0, 0, 0, 0.15) 2.4px 2.4px 3.2px",
        }}
      >
        <CardHeader
          onClick={() => navigate(`/user-profile/${inte?.userId}`)}
          className="title__link"
          avatar={
            <Stack direction="column">
              {uploader?.profile ? (
                <Avatar src={uploader?.profile} />
              ) : (
                <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
                  {uploader?.name?.at(0)?.toUpperCase()}
                </Avatar>
              )}
            </Stack>
          }
          // action={
          //   <IconButton aria-label="settings">
          //     <MoreVertIcon />
          //   </IconButton>
          // }
          title={uploader?.name?.toUpperCase()}
          subheader={new Date(inte?.createdAt).toDateString()}
        />
        <CardContent sx={{ marginTop: "-20px" }}>
          <Box
            sx={{
              boxShadow: "none",
              padding: "20px 0",
            }}
          >
            <Typography
              variant="h5"
              sx={{
                textTransform: "whitesmoke",
                fontWeight: "600",
                cursor: "pointer",
              }}
              className="title__link"
              onClick={() => navigate(`/internship-details/${inte?._id}`)}
            >
              {inte?.generalData?.internshipTitle}
            </Typography>
            <Grid container gap={1} sx={{ marginTop: "20px" }}>
              <Grid item lg={2} xs={12}>
                <img
                  src={inte?.companyLogoImage}
                  style={{ width: "70px", height: "70px" }}
                />
              </Grid>
              <Grid item xs={12} lg={9.8}>
                <Grid container gap={6}>
                  <Grid
                    item
                    xs={10}
                    lg={5}
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                      marginTop: { xs: "20px", lg: "0" },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {" "}
                      <Typography
                        variant="body2"
                        sx={{
                          width: "120px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        <LocationCityIcon
                          sx={{ color: "gray", marginRight: "5px" }}
                        />
                        Company
                      </Typography>
                      <Typography variant="body2">
                        {inte?.generalData?.companyName}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          width: "120px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        <LocationOnIcon
                          sx={{ color: "gray", marginRight: "5px" }}
                        />
                        Location
                      </Typography>
                      <Typography variant="body2">
                        {inte?.generalData?.city},{inte?.generalData?.state}{" "}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          width: "120px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        <CallIcon sx={{ color: "gray", marginRight: "5px" }} />
                        Contact
                      </Typography>
                      <Typography variant="body2">
                        {inte?.generalData?.contact}
                      </Typography>
                    </Box>
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    lg={5}
                    sx={{
                      display: "flex",
                      gap: "10px",
                      flexDirection: "column",
                    }}
                  >
                    <Box sx={{ display: "flex" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          width: "120px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        <CreditCardIcon
                          sx={{ color: "gray", marginRight: "5px" }}
                        />
                        Stipend
                      </Typography>
                      <Typography variant="body2">
                        {inte?.generalData?.stipend}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          width: "120px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        <CalendarMonthIcon
                          sx={{ color: "gray", marginRight: "5px" }}
                        />
                        Last Date
                      </Typography>
                      <Typography variant="body2">
                        {inte?.generalData?.lastDateToApply}{" "}
                      </Typography>
                    </Box>

                    <Box sx={{ display: "flex" }}>
                      <Typography
                        variant="body2"
                        sx={{
                          width: "120px",
                          fontWeight: "600",
                          color: "#777",
                        }}
                      >
                        <TimelapseIcon
                          sx={{ color: "gray", marginRight: "5px" }}
                        />
                        Duration
                      </Typography>
                      <Typography variant="body2">
                        {inte?.generalData?.duration}
                      </Typography>
                    </Box>
                  </Grid>
                </Grid>
                <Box sx={{ marginTop: "20px" }}>
                  <Typography>Required Skills</Typography>
                  <Box sx={{ display: "flex" }}>
                    {inte?.skills?.map((f) => (
                      <Typography
                        variant="body2"
                        sx={{
                          border: "1px solid lightgray",
                          width: "max-content",
                          padding: "2px 4px",
                          margin: "3px",
                          color: "colorThree.main",
                        }}
                      >
                        {f}
                      </Typography>
                    ))}
                  </Box>
                </Box>
                {/* <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                  <button
                    style={{
                      marginLeft: "auto",
                      marginTop: "10px",
                      textDecoration: "underline",
                    }}
                    className=""
                    onClick={() => navigate(`/internship-details/${inte?._id}`)}
                  >
                    details
                  </button>
                </Box> */}
                {currentUser?.isAdmin && (
                  <button
                    className="asc__submit__form__button"
                    onClick={() => deleteInternship(inte)}
                  >
                    Delete Internship
                  </button>
                )}
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>
    </>
    // <Card sx={{ width: "100%" }}>
    //   <CardHeader
    //     avatar={
    //       <Stack direction="column">
    //         {uploader?.profile ? (
    //           <Avatar
    //             src={uploader?.profile}
    //             alt={uploader?.name?.at(0)?.toUpperCase()}
    //           />
    //         ) : (
    //           <Avatar sx={{ bgcolor: "colorThree.main" }} aria-label="recipe">
    //             {uploader?.name?.at(0)?.toUpperCase()}
    //           </Avatar>
    //         )}
    //       </Stack>
    //     }
    //     // action={
    //     //   <IconButton aria-label="settings">
    //     //     <MoreVertIcon />
    //     //   </IconButton>
    //     // }
    //     title={uploader?.name?.toUpperCase()}
    //     subheader={new Date(inte?.createdAt).toDateString()}
    //   />

    //   <CardContent>
    //     <Typography
    //       sx={{
    //         fontSize: "1.5rem",
    //         marginBottom: "10px",
    //         fontWeight: "500",
    //         textTransform: "capitalize",
    //       }}
    //       color="fontPrimaryColor.main"
    //       className="question__title"
    //       // onClick={() => navigate(`/answers/${question._id}`)}
    //     >
    //       {inte?.companyName}
    //     </Typography>
    //     <Typography variant="body2" color="text.secondary">
    //       {inte?.description}
    //     </Typography>

    //     <Box className="language mt-4 bg-white">
    //       <Box className="tags bg-white">
    //         {inte?.tags?.map((t) => (
    //           <Typography className="tag-span">{t}</Typography>
    //         ))}
    //       </Box>
    //     </Box>

    //     <Box
    //       className="country mt-2 mb-1"
    //       sx={{ display: "flex", gap: "20px", alignItems: "center" }}
    //     >
    //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
    //         Location
    //       </Typography>
    //       <Typography variant="body2">{inte?.location} </Typography>
    //     </Box>
    //     <Box
    //       className="duration mb-1"
    //       sx={{ display: "flex", gap: "20px", alignItems: "center" }}
    //     >
    //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
    //         Duration
    //       </Typography>
    //       <Typography>{inte?.duration} </Typography>
    //     </Box>
    //     <Box
    //       className="duration mb-1"
    //       sx={{ display: "flex", gap: "20px", alignItems: "center" }}
    //     >
    //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
    //         Pay/Stipend
    //       </Typography>
    //       <Typography>{inte?.pay} PKR</Typography>
    //     </Box>

    //     <Box
    //       className="visitlink"
    //       sx={{ display: "flex", gap: "20px", alignItems: "center" }}
    //     >
    //       <Typography variant="body2" sx={{ fontWeight: "600" }}>
    //         Visit link
    //       </Typography>
    //       <Typography
    //         sx={{
    //           color: "blue",
    //           cursor: "pointer",
    //           textDecoration: "underline",
    //         }}
    //       >
    //         {inte?.url ? inte?.url : "null"}
    //       </Typography>
    //     </Box>
    //     {currentUser?.isAdmin && (
    //       <button
    //         className="asc__submit__form__button"
    //         onClick={() => deleteInternship(inte)}
    //       >
    //         Delete Scholarship
    //       </button>
    //     )}
    //   </CardContent>
    // </Card>
  );
};
